export interface ICountryMask {
  maskCarPlate: string;
  maskIdCompany: string;
  maskIdPerson: string;
  maskPhone: string;
  maskCityCode: string;
  maskVin: string;
  useMaskCityCodeToPhone: string;

  // TODO: Talvez substituir maskPhone e maskCityCode pelos campos abaixo?
  // Estão vindo assim do BFF:
  phone?: string;
  cityCode?: string;
}
